import { baseTheme } from '@src/theme';
import { Tooltip } from 'antd';
import { ComponentType } from 'react';
import { styled } from 'styled-components';

export const StyledTooltip = styled(Tooltip as ComponentType<any>)`
    .ant-tooltip-content {
        .ant-tooltip-inner {
            background-color: ${(props) =>
                props.theme?.colors?.secondary?.dark?.filled ||
                baseTheme.colors.secondary.dark.filled};
            color: ${(props) =>
                props.theme?.colors?.secondary?.dark?.text ||
                baseTheme.colors.secondary.dark.text};
            border-radius: 4px;
            padding: 8px 12px;
            font-size: 1rem;
        }
    }
`;

export const StyledIconWrapper = styled.span`
    color: ${(props) =>
        props.theme?.colors?.secondary?.main?.icon ||
        baseTheme.colors.secondary.main.icon};
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
        color: ${(props) =>
            props.theme?.colors?.secondary?.dark?.icon ||
            baseTheme.colors.secondary.dark.icon};
    }
`;
